import { render, staticRenderFns } from "./NavBase.vue?vue&type=template&id=470df987&scoped=true&"
import script from "./NavBase.vue?vue&type=script&lang=js&"
export * from "./NavBase.vue?vue&type=script&lang=js&"
import style0 from "./NavBase.vue?vue&type=style&index=0&id=470df987&scoped=true&lang=css&"
import style1 from "./NavBase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470df987",
  null
  
)

export default component.exports